module.exports = __webpack_public_path__ + "media/images/undraw/psc/add_information-aba9b42b3db4e4443928731a341bede5.png";